/**
 * RegistroCompra Feature
 * Servicios, mappers, modelos API
 */

export * from './graphql/registro-compra.queries';
export * from './graphql/registro-compra.mutations';
export * from './services/registro-compra.service';
export * from './services/registro-compra-upload.service';
